import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_FRIEND_REQUEST').plugin(axiosPlugin);

let updateUserFriendsRequestAction = redux.fetchActionUpdate();

export const TYPES = redux.types;

export const updateUserFriendRequest = (userId, answerId) => updateUserFriendsRequestAction(`/users/${userId}/answers/${answerId}/accepted`);
export const deleteUserFriendRequest = (userId, answerId) => updateUserFriendsRequestAction(`/users/${userId}/answers/${answerId}/refused`);
export const resetUserFriendRequest = () => redux.actions.reset();

export const userFriendRequest = redux.reducer();
